// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__VPrRZ","left":"styles_left__1QTmj","right":"styles_right__2ZXPK","alert":"styles_alert__A9mJZ"};